// Dependencies
import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx'

// Styles
import './Header.scss';

function Header() {
	const context = React.useContext(ThemeContext);
	const style = {
		header: {
			color: context.themeManager.value('header', 'color', 'fg-color-header'),
			backgroundColor: context.themeManager.value('header', 'background', 'bg-color-header'),
			fontSize: context.themeManager.value('header', 'fontSize', 'font-size-200'),
			lineHeight: context.themeManager.value('header', 'lineHeight', 'line-height-200'),
			margin: context.themeManager.value('header', 'headerMargin', 'header-margin-mobile'),
			height: context.themeManager.value('header', 'height', 'header-height-mobile'),
			borderLeft: context.themeManager
				.valueOrDefault('header', 'borderLeft', null, 'none'),
			borderTop: context.themeManager
				.valueOrDefault('header', 'borderTop', null, 'none'),
			borderRight: context.themeManager
				.valueOrDefault('header', 'borderRight', null, 'none'),
			borderBottom: context.themeManager
				.valueOrDefault('header', 'borderBottom', null, 'none'),
			'@media (min-width : 500px)': {
				height: context.themeManager.value('header', 'height', 'header-height-500'),
			},
			'@media (min-width : 600px)': {
				height: context.themeManager.value('header', 'height', 'header-height-600'),
			},
			'@media (min-width : 700px)': {
				height: context.themeManager.value('header', 'height', 'header-height-700'),
			},
			'@media (min-width : 768px)': {
				height: context.themeManager.value('header', 'height', 'header-height-768'),
				margin: context.themeManager.value('header', 'headerMargin', 'header-margin-desktop'),
				borderLeft: context.themeManager
					.valueOrDefault('header', 'borderLeftDesktop', null, 'none'),
				borderTop: context.themeManager
					.valueOrDefault('header', 'borderTopDesktop', null, 'none'),
				borderRight: context.themeManager
					.valueOrDefault('header', 'borderRightDesktop', null, 'none'),
				borderBottom: context.themeManager
					.valueOrDefault('header', 'borderBottomDesktop', null, 'none'),
			},
			'@media (min-width : 992px)': {
				height: context.themeManager.value('header', 'height', 'header-height-992'),
			},
			'@media (min-width : 1200px)': {
				height: context.themeManager.value('header', 'height', 'header-height-desktop'),
			},

		},
		logo: {
			height: '100%',
			width: '100%',
			backgroundImage: `url(${context.themeManager.value('header', 'backgroundImage', 'bg-image-header')})`,
			backgroundSize: context.themeManager
				.valueOrDefault('headerLogo', 'backgroundSize', null, 'cover'),
			backgroundPosition: context.themeManager
				.valueOrDefault('headerLogo', 'backgroundPosition', null, 'center'),
		},
	};

	return (
		<header className="header" style={style.header}>
			<div
				className="logo"
				style={style.logo}
				role={"img"}
				aria-label="Headerbild für das Ticketschop"
			/>
		</header>
	);
}

export default radium(Header);
